module.exports = __webpack_public_path__ + "img/audix.50e68794.jpg";